import * as _ from "lodash";
import { Input } from "@mui/joy";
import { useEffect, useRef, useState } from "react";
import { ProgramContentType } from "data/BlockComponent";
import { PercentageType } from "data/CellComponent";
import { useTranslation } from "react-i18next";

export default function PercentageInput({
  id,
  initialPercentage,
  index,

  setData,
  lineIndex,
  cellIndex,
  inputKey,
}: {
  id?: string;
  initialPercentage?: number;
  index: number;

  setData: React.Dispatch<
    React.SetStateAction<ProgramContentType[] | undefined>
  >;
  lineIndex: number;
  cellIndex: number;
  inputKey?: string;
}) {
  const { t: t_common } = useTranslation("translation", {
    keyPrefix: "task.activity.common",
  });

  const handleChange = (percentage: number) => {
    setData((data) => {
      if (data) {
        const data_temp = _.cloneDeep(data);
        const currentContent =
          data_temp[index].lines[lineIndex][cellIndex].content || {};

        data_temp[index].lines[lineIndex][cellIndex].content = {
          ...currentContent,
          value:
            percentage !== undefined && !isNaN(percentage)
              ? `${Math.max(0, Math.min(percentage, 100))}`
              : undefined,
          percentage:
            percentage !== undefined && !isNaN(percentage)
              ? Math.max(0, Math.min(percentage, 100))
              : undefined,
        };

        if (!_.isEqual(data, data_temp)) {
          return data_temp;
        }
        return data;
      }
      return data;
    });
  };

  useEffect(() => {
    if (initialPercentage !== undefined) {
      handleChange(initialPercentage);
    }
  }, [initialPercentage]);

  const [isFocused, setIsFocused] = useState<boolean>(false);

  return (
    <Input
      key={inputKey}
      value={initialPercentage}
      {...(id?.startsWith("영향받는 정도") && {
        placeholder: t_common("영향 정도 placeholder"),
      })}
      type={"tel"}
      onChange={(e) => {
        const percentage = parseInt(e.target.value);
        handleChange(percentage);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          if (isFocused) {
            (document.activeElement as HTMLInputElement)?.blur();
            setIsFocused(false);
          }
        }
      }}
      slotProps={{ input: { min: 0, max: 100, step: 5 } }}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      sx={{
        textAlign: "center",
        borderRadius: "4px",
        borderWidth: 1,
        borderColor: isFocused ? "primary.solid" : "primary.deactivated",
        px: "12px",
        py: "5px",
        "--Input-minHeight": 0,

        backgroundColor: "transparent",
      }}
    />
  );
}
